// Écran de connexion (R-AUTH-01, R-AUTH-02, R-AUTH-03).
import { useState, type FormEvent } from 'react';
import { Link, useNavigate } from 'react-router';
import { magasin, useMagasin } from '../donnees/magasin';
import { ErreurApi, estHorsLigne } from '../api';

export function Connexion() {
  const { utilisateur } = useMagasin();
  const naviguer = useNavigate();
  const [email, setEmail] = useState(utilisateur ?? '');
  const [motDePasse, setMotDePasse] = useState('');
  const [rester, setRester] = useState(true);
  const [erreur, setErreur] = useState<string>();
  const [enCours, setEnCours] = useState(false);

  async function soumettre(e: FormEvent) {
    e.preventDefault();
    setErreur(undefined);
    setEnCours(true);
    try {
      await magasin.connexion(email.trim(), motDePasse, rester);
      naviguer('/', { replace: true });
    } catch (err) {
      if (err instanceof ErreurApi) setErreur(err.message);
      else if (estHorsLigne(err)) setErreur('Pas de réseau. La connexion nécessite Internet ; tes données locales sont conservées.');
      else setErreur('Erreur inattendue. Réessaie.');
    } finally {
      setEnCours(false);
    }
  }

  return (
    <div className="connexion-page">
      <form className="carte" onSubmit={soumettre}>
        <h1>Formation</h1>
        <p className="doux">Développeur → Product Architect</p>
        {erreur ? <div className="message erreur" role="alert">{erreur}</div> : null}
        <div className="champ">
          <label htmlFor="email">Email</label>
          <input id="email" type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} />
        </div>
        <div className="champ">
          <label htmlFor="mdp">Mot de passe</label>
          <input id="mdp" type="password" autoComplete="current-password" required value={motDePasse} onChange={(e) => setMotDePasse(e.target.value)} />
        </div>
        <div className="champ">
          <label style={{ fontWeight: 400 }}><input type="checkbox" checked={rester} onChange={(e) => setRester(e.target.checked)} />Rester connecté sur cet appareil (90 jours, pour le hors-ligne)</label>
        </div>
        <button className="principal" type="submit" disabled={enCours}>{enCours ? 'Connexion…' : 'Se connecter'}</button>
        <p className="petit-texte" style={{ marginTop: '1em' }}><Link to="/mot-de-passe-oublie">Mot de passe oublié ?</Link></p>
        {utilisateur ? <p className="petit-texte doux">Des données locales existent pour {utilisateur}. <Link to="/">Continuer hors ligne</Link></p> : null}
      </form>
    </div>
  );
}
